import { render, staticRenderFns } from "./UnsettledOrders.vue?vue&type=template&id=7fd189fd&scoped=true"
import script from "./UnsettledOrders.vue?vue&type=script&lang=js"
export * from "./UnsettledOrders.vue?vue&type=script&lang=js"
import style0 from "./UnsettledOrders.vue?vue&type=style&index=0&id=7fd189fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd189fd",
  null
  
)

export default component.exports